
































































































































































































































































































































import {Component, Prop, Vue} from "vue-property-decorator";
import Formulario from "@/components/Formulario.vue";
import info from "@/info";

@Component({
  name: "ModelSelector",
  components: {
    Formulario,
  },
})
  export default class ModelSelector extends Vue {
    // Public PROPS
    @Prop() model  ?: string

    @Prop() indexYear ?: number;
    @Prop() indexModel ?: number = 0;
    @Prop() indexColor ?: number = 0;
    @Prop() indexTransmision ?: number = 0;

    public modelInfo: object = {};
    public selectedYear: string = '';
    public selectedModel: string = '';
    public selectedColor: string = '';
    public selectedTransmision: string = '';


    public clickedModel: string = "";
    public aIndex: object = {};
    public currentModel: string = "";

    public engPercent: number = 55;
    public engTotal: number = 0;
    public engTotalFixed: string = "";
    public plazTotal: number = 60;
    public plazTotalIndex: number = 4;
    public mensTotal: number = 0;
    public mensTotalFixed: string = "";
    public mensMin: number = 1;
    public mensMinFixed: string = "";
    public mensMax: number = 10;
    public mensMaxFixed: string = "";
    public priceTotal: number= 0;
    public interesT: number = 0;
    public seguroAuto: number = 0;
    public seguroAutoFixed: string = "";
    public contadoIVA: number = 0;
    public constIVA: number = 0;
    public financiadoIVA: number = 0;
    public IVAF: number = 0;
    public IVAFixed: string = "";
    public ivaIndex: number = 0;
    public pagoIniT: number = 0;
    public pagoIniTFixed: string = ""; 
    public pagoMensT: number = 0; /*-- new --*/
    public pagoMensTFixed: string = ""; /*-- new --*/


    scrollState(state: string) {
      const elem = document.getElementById("scrollBlock");
      elem!.style.overflow = state;
    }
    /* --------------------- */
    public rangesSliderEng() {
      const sliderEl = document.querySelector("#rangeSEng");
      const sliderEl2 = document.querySelector("#rangeSMens");

      sliderEl2!.addEventListener("input", (event2) => {
        let tempSliderValue2 = (event2.target as HTMLInputElement).value;
        this.mensTotal = Number(tempSliderValue2)
        
        const progress2 = ((Number(tempSliderValue2)-Number((sliderEl2 as HTMLInputElement).min))/(Number((sliderEl2 as HTMLInputElement).max)-Number((sliderEl2 as HTMLInputElement).min)))*100;
        this.engPercent  = Math.round((((100 - progress2)/ 100) * (85 - 20)) + 20);

        this.operationsForm()
      })

      sliderEl!.addEventListener("input", (event) => {
        let tempSliderValue = (event.target as HTMLInputElement).value;
        this.engPercent = Number(tempSliderValue)

        this.operationsForm()
      })
    }

    public setRadioP(value: string) {
        document.querySelectorAll(`input[name="pazos"]`).forEach(element => {
            if((element as HTMLInputElement).value === value) {
              (element as HTMLInputElement).checked = true;
            }
        });
    }

    public RadioP() {
        document.querySelectorAll(`input[name="pazos"]`).forEach(element => {
            if((element as HTMLInputElement).checked === true) {
              this.plazTotalIndex = Number((element as HTMLInputElement).value);
              this.plazTotal = 12 * (this.plazTotalIndex+1);
              this.operationsForm();
            }
        });
    }

    public radioIVA() {
      document.querySelectorAll(`input[name="seguro"]`).forEach(element => {
        console.log("test1");
          if((element as HTMLInputElement).checked === true) {
            if((element as HTMLInputElement).value === "0") {
              this.ivaIndex = 0;
            }
            if((element as HTMLInputElement).value === "1") {
              this.ivaIndex = 1;
            }
            this.operationsForm();
          }
      });
    }

    operationsForm(): void {
      this.engTotal = (this.engPercent/100)*this.priceTotal;
      this.engTotalFixed = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(this.engTotal);

      const interestRates = [6.87, 13.54, 20.52, 27.82, 35.43, 43.33];
      const interestCoefficients = [0.085, 0.17, 0.25, 0.35, 0.45, 0.54];

      this.interesT = interestRates[this.plazTotalIndex] - ((this.engPercent - 20) * interestCoefficients[this.plazTotalIndex]);

      this.mensMin = ((((this.priceTotal * (interestRates[this.plazTotalIndex] - ((20 - 20) * interestCoefficients[this.plazTotalIndex])))/100) + this.priceTotal) - (0.20 * this.priceTotal)) / this.plazTotal;
      this.mensMinFixed = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(this.mensMin);
      
      this.mensMax = ((((this.priceTotal * (interestRates[this.plazTotalIndex] - ((85 - 20) * interestCoefficients[this.plazTotalIndex])))/100) + this.priceTotal) - (0.85 * this.priceTotal)) / this.plazTotal;
      this.mensMaxFixed = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(this.mensMax);

      this.mensTotal = ((((this.priceTotal*this.interesT)/100)+this.priceTotal) - this.engTotal)/this.plazTotal;
      this.mensTotalFixed = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(this.mensTotal);

      if(this.ivaIndex === 0) {
        this.IVAF = this.contadoIVA - (this.constIVA * (this.engPercent-20));
        this.IVAFixed = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(this.IVAF);
      }
      if(this.ivaIndex === 1) {
        this.IVAF = (this.contadoIVA - (this.constIVA * (this.engPercent-20))) + this.financiadoIVA;
        this.IVAFixed = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(this.IVAF);
      }

      this.pagoIniT = this.engTotal +  this.IVAF; /*-- ajustado --*/	
      this.pagoMensT = this.mensTotal + (this.IVAF/12);
      if(this.ivaIndex === 0) {
        this.pagoIniT = this.pagoIniT + this.seguroAuto;
      }
      if(this.ivaIndex === 1) {
        this.pagoMensT = this.pagoMensT + (this.seguroAuto/12);
      }
      this.pagoMensTFixed = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(this.pagoMensT);
      this.pagoIniTFixed = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(this.pagoIniT); /*-- ajustado --*/

      const sliderEl2 = document.querySelector("#rangeSMens");

      (sliderEl2 as HTMLInputElement).min = String(this.mensMax);
      (sliderEl2 as HTMLInputElement).max = String(this.mensMin);
      (sliderEl2 as HTMLInputElement).value = String(this.mensTotal);
      const progress2 = ((this.mensTotal-Number((sliderEl2 as HTMLInputElement).min))/(Number((sliderEl2 as HTMLInputElement).max)-Number((sliderEl2 as HTMLInputElement).min)))*100;
      (sliderEl2 as HTMLInputElement).style.background = `linear-gradient(to right, #017fff ${progress2}%, #ccc 0%)`;

      const sliderEl = document.querySelector("#rangeSEng");
      const progress = ((this.engPercent-Number((sliderEl as HTMLInputElement).min))/(Number((sliderEl as HTMLInputElement).max)-Number((sliderEl as HTMLInputElement).min)))*100;
      (sliderEl as HTMLInputElement).style.background = `linear-gradient(to right, #017fff ${progress}%, #ccc 0%)`;
      (sliderEl as HTMLInputElement).value = String(this.engPercent);
    }
    /* --------------------- */
    openMenuFormM(): void {

      let curtainForm = document.getElementById("curtain-formM");
      let menuForm = document.getElementById("menu-formM");

      if (curtainForm) {
      curtainForm.style.display = "block";
      }
      menuForm?.classList.remove("disable-menu-formM");
      menuForm?.classList.add("open-menu-formM");

    }
    closeMenuFormM() {

        let curtainForm = document.getElementById("curtain-formM");
        let menuForm = document.getElementById("menu-formM");

        if (curtainForm) {
        curtainForm.style.display = "none";
        }
        menuForm?.classList.remove("open-menu-formM");
        menuForm?.classList.add("disable-menu-formM");
    }
    openMenuFormM2(): void {
      let menuForm = document.getElementById("menu-formM-2");

      menuForm?.classList.remove("disable-menu-formM-2");
      menuForm?.classList.add("open-menu-formM-2");

    }
    closeMenuFormM2() {

      let menuForm = document.getElementById("menu-formM-2");

      menuForm?.classList.remove("open-menu-formM-2");
      menuForm?.classList.add("disable-menu-formM-2");
    }
    openMenuFormMF(): void {
      const idDivModel = document.getElementById("uk-navbar-dropdown-id-ml");
      const idDiv = document.getElementById("uk-navbar-dropdown-id");

      if (idDivModel) {
          idDivModel.style.display = "none";}
      if (idDiv) {
        idDiv.style.display =  "none";}


      let curtainForm = document.getElementById("curtain-formMF");
      let menuForm = document.getElementById("menu-formMF");

      if (curtainForm) {
        curtainForm.style.display = "block";
      }
      menuForm?.classList.remove("disable-menu-formMF");
      menuForm?.classList.add("open-menu-formMF");
    }
    closeMenuFormMF() {

      let curtainForm = document.getElementById("curtain-formMF");
      let menuForm = document.getElementById("menu-formMF");

      if (curtainForm) {
        curtainForm.style.display = "none";
      }
      menuForm?.classList.remove("open-menu-formMF");
      menuForm?.classList.add("disable-menu-formMF");
    }

    openMenuFormMS(auto: string, i: object, sA: number, IVA: number, constIVA: number, fIVA: number, p: number): void {
      this.priceTotal = p;
      this.selectedModel = this.currentModel;
      this.clickedModel = auto;
      this.aIndex = i;
      this.seguroAuto = sA;
      this.seguroAutoFixed = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(this.seguroAuto);
      this.contadoIVA = IVA;
      this.constIVA = constIVA;
      this.financiadoIVA = fIVA;

      const idDivModel = document.getElementById("uk-navbar-dropdown-id-ml");
      const idDiv = document.getElementById("uk-navbar-dropdown-id");

      if (idDivModel) {
          idDivModel.style.display = "none";}
      if (idDiv) {
        idDiv.style.display =  "none";}


      let curtainForm = document.getElementById("curtain-formMS2");
      let menuForm = document.getElementById("menu-formMS2");

      if (curtainForm) {
        curtainForm.style.display = "block";
      }
      menuForm?.classList.remove("disable-menu-formMS2");
      menuForm?.classList.add("open-menu-formMS2");

      this.IVAF = this.contadoIVA - (this.constIVA * (this.engPercent-20));
      this.IVAFixed = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(this.IVAF);

      const sliderEl2 = document.querySelector("#rangeSMens");

      (sliderEl2 as HTMLInputElement).min = String(this.mensMax);
      (sliderEl2 as HTMLInputElement).max = String(this.mensMin);


      this.rangesSliderEng();
      this.setRadioP(String(this.plazTotalIndex));
      this.operationsForm();
    }
    closeMenuFormMS() {

      let curtainForm = document.getElementById("curtain-formMS2");
      let menuForm = document.getElementById("menu-formMS2");

      if (curtainForm) {
        curtainForm.style.display = "none";
      }
      menuForm?.classList.remove("open-menu-formMS2");
      menuForm?.classList.add("disable-menu-formMS2");
    }
    mounted() {
      for (let i in info.home.headerSlider) {
        if (info.home.headerSlider[i].name === this.model) {
          this.modelInfo = info.home.headerSlider[i];
        }
      }
    }

    checkAño(btnID: string, i: number) {
      this.selectedYear = btnID;
      this.indexYear = i;
      document.querySelectorAll(`input[name="modelModels"]`).forEach(element => {
        if((element as HTMLInputElement).id === "model-0") {
          (element as HTMLInputElement).checked = true;
          this.indexModel = 0;
        }
      });
      document.querySelectorAll(`input[name="colorModels"]`).forEach(element => {
        if((element as HTMLInputElement).id === "color-0") {
          (element as HTMLInputElement).checked = true;
          this.indexColor = 0;
        }
      });
      document.querySelectorAll(`input[name="transmisionModels"]`).forEach(element => {
        if((element as HTMLInputElement).id === "trasmision-0") {
          (element as HTMLInputElement).checked = true;
          this.indexTransmision = 0;
        }
      });
    }
    checkModel(btnID: string, i: number) {
      this.selectedModel = btnID;
      this.indexModel = i;
      document.querySelectorAll(`input[name="colorModels"]`).forEach(element => {
        if((element as HTMLInputElement).id === "color-0") {
          (element as HTMLInputElement).checked = true;
          this.indexColor = 0;
        }
      });
      document.querySelectorAll(`input[name="transmisionModels"]`).forEach(element => {
        if((element as HTMLInputElement).id === "trasmision-0") {
          (element as HTMLInputElement).checked = true;
          this.indexTransmision = 0;
        }
      });
    }
    checkColor(btnID: string, i: number) {
      this.selectedColor = btnID;
      this.indexColor = i;
  }
  checkTransmision(btnID: string, i: number) {
      this.selectedTransmision = btnID;
      this.indexTransmision = i;
  }
}
